import axios from "axios";
import AuthServices from "./AuthServices";
import queryString from "query-string";

const ProtocolServices = {
  getProtocols: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/protocol?${queryString.stringify(data)}`
    );
    return response;
  },
  getProtocol: async (id = null) => {
    const args = id !== null ? `?protocol_id=${id}` : "";
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/protocol${args}`
    );
    return response;
  },
  getProtocolsSubscription: async (id = null) => {
    const args = id !== null ? `?subscription_id=${id}` : "";
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/protocol${args}`
    );
    return response;
  },
  searchProtocols: async (
    subscription_id = null,
    enterprise_id = null,
    name = ""
  ) => {
    let args = `?subscription_id=${subscription_id}&enterprise_id=${enterprise_id}`;
    if (name !== "") {
      args += `&name=${name}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/service/search-protocol${args}`
    );
    return response;
  },
  saveProtocol: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/protocol`,
      data
    );
    return response;
  },
  updateProtocol: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/protocol`,
      data
    );
    return response;
  },
  getProtocolDetails: async (id, data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/protocol/details?id=${id}&${queryString.stringify(data)}`
    );
    return response;
  },
  saveProtocolDetails: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/protocol/details`,
      data
    );
    return response;
  },
  deleteProtocolDetails: async (protocol, protocol_detail) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL +
        `/eira/protocol/details?protocol=${protocol}&protocol_detail=${protocol_detail}`
    );
    return response;
  },
  saveProtocolCondition: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/protocol/condition`,
      data
    );
    return response;
  },
  deleteProtocolCondition: async (protocol_condition_id) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL +
        `/eira/protocol/condition?protocol_condition_id=${protocol_condition_id}`
    );
    return response;
  },
  getSurveys: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/survey/?${queryString.stringify(data)}`
    );
    return response;
  },
  assignSurveyToUser: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/survey/assign`,
      data
    );
    return response;
  },
  getPill: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/pill?${queryString.stringify(data)}`
    );
    return response;
  },
  clone: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/service/clone-protocol`,
      data
    );
    return response;
  },
  getDays: async (protocol_id) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/protocol-days?protocol_id=${protocol_id}`
    );
    return response;
  },
};

export default ProtocolServices;
